var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{style:({'height':'20vh'})},[_c('v-divider',{attrs:{"color":"black"}}),_c('v-row',{staticClass:"mt-12"},[_c('h4',{staticClass:"font-weight-regular"},[_vm._v("© 2021")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }